import {debounce} from "lodash";

import {IDLE_DELAY} from "@toolbox/models";

/** time multiplied by 250ms */
export default async function sleep(time: number, useMilli: boolean = false) {
    const duration = useMilli ? time : time * IDLE_DELAY;
    const wait = debounce((resolve) => resolve(), duration);
    await new Promise((resolve) => wait(resolve));
}

export async function sleepingBeauty(
    triggers: (() => void)[],
    wait1LittleAfter: boolean = true,
) {
    const long = debounce((resolve) => resolve(), 14400);
    const short = debounce((resolve) => resolve(), IDLE_DELAY);
    await new Promise((resolve) => {
        // sleep for n hour
        long(resolve);
        triggers.push(() => {
            long.cancel();
            if (wait1LittleAfter) {
                short(resolve);
            }
        });
    });
}

export async function princePhillip(triggers: (() => void)[]) {
    const _triggers = [...triggers];
    triggers.length = 0;
    for (const trigger of _triggers) {
        trigger();
    }

    await sleep(1);
}

export async function wake1(triggers: (() => void)[]) {
    const a = triggers.shift();
    a?.();
}
